import React from "react";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";

const ModalShell = ({ title, children, footer, onClose }) => (
  <div className="fixed inset-0 z-[80] flex items-end justify-center bg-black/40 p-0 backdrop-blur-sm sm:items-center sm:p-4">
    <div className="flex max-h-[92dvh] w-full max-w-3xl flex-col rounded-t-3xl bg-white shadow-2xl sm:rounded-3xl">
      <div className="sticky top-0 z-10 flex items-center justify-between border-b border-gray-100 bg-white px-5 py-4 sm:px-6">
        <h2 className="text-base font-extrabold text-gray-900 sm:text-lg">
          {title}
        </h2>
        <button
          type="button"
          onClick={onClose}
          className="flex h-9 w-9 items-center justify-center rounded-full bg-gray-100 text-gray-500 transition hover:bg-gray-200"
          aria-label="Close"
        >
          <CloseOutlinedIcon style={{ fontSize: 18 }} />
        </button>
      </div>
      <div className="flex-1 overflow-y-auto p-5 sm:p-6">{children}</div>
      {footer && (
        <div className="sticky bottom-0 border-t border-gray-100 bg-white p-4 sm:px-6">
          {footer}
        </div>
      )}
    </div>
  </div>
);

export default ModalShell;
